import { getFontFamilies, getSkinParams, extractFromQuotes, extractFontFamiliesFromCssProperties } from '@wix/thunderbolt-becky-root'
import type { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCompNode, envRefs } from '@wix/thunderbolt-catharsis'
import { findFontsInCss } from '@wix/stylable-viewer-flatten/dist/fonts/fonts-stylable'
import _ from 'lodash'
import { EMPTY_ARRAY } from '../../../utils/constants'
import type { FeatureRefs } from '../../cssFeatures.types'
import { getSTCSS } from '../../../utils/selectorsUtils'

const getFontsFromStyle = (style: Style, componentsSkinParams: any): Array<string> => {
	if (style.cssProperties) {
		return extractFontFamiliesFromCssProperties(style.cssProperties)
	}

	const stylableStCss = getSTCSS(style)
	if (stylableStCss) {
		return findFontsInCss(stylableStCss, () => true, false)
	}

	const skinParams = getSkinParams(style.skin, componentsSkinParams)
	return _.flatMap(style.style?.properties, (styleProperty, styleParam) => {
		if (typeof styleProperty !== 'string') {
			return EMPTY_ARRAY
		}

		if (skinParams?.types[styleParam] === 'FONT') {
			return getFontFamilies(styleProperty)
		}
		if (styleParam === 'fontFamily' || skinParams?.types[styleParam] === 'FONT_FAMILY') {
			return styleProperty.split(',').map((fontFamily) => extractFromQuotes(fontFamily))
		}
		return EMPTY_ARRAY
	})
}

export const styleFontFamilies = {
	predicate: () => true,
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => {
			return {
				compStyles: refs.compStyles(component),
				componentsSkinParams: envRefs.componentsSkinParams,
			}
		},
		toViewItem: (__, { compStyles, componentsSkinParams }) => {
			if (!compStyles) {
				return EMPTY_ARRAY
			}
			if (compStyles.type === 'classic') {
				return Object.values(compStyles.css).flatMap((variant) =>
					getFontsFromStyle(variant, componentsSkinParams)
				)
			}
			return Object.values(compStyles.css).flatMap((variants) =>
				Object.values(variants).flatMap((variant) => getFontsFromStyle(variant, componentsSkinParams))
			)
		},
	}),
}
